// SIPP-821: single source of truth for the Stripe Payment Link URLs used
// across the Recommendations tab. When a URL changes, update it here — the
// previous per-component duplicates drifted (SippProUpgradeSection and
// BrandModelSearch carried different SIPP Pro links).

export const STRIPE_PRO_ANNUAL_URL =
  'https://buy.stripe.com/dRm7sKdvj6As26W1vfak002'

export const STRIPE_SMART_HOME_URL =
  'https://buy.stripe.com/aFaeVcdvj5wo9zogq9ak003'

// SIPP-824: dedicated Stripe Payment Link for the $900 4-unit bundle.
export const STRIPE_SMART_HOME_BUNDLE_URL =
  'https://buy.stripe.com/6oU28q62R1g88vkgq9ak004'
